import React, {useContext, useEffect} from 'react'
import {Loader} from 'semantic-ui-react'

const LoadingIndicator = (props) => {
  const {loaderText, loaderInline = true, loaderStyle = {}} = props
  const style = {...{marginTop: '25px', marginBottom: '25px'}, ...loaderStyle}
  const inline = loaderInline ? 'centered' : false
  if (loaderText) {
    return (<Loader active inline={inline} style={style}>{loaderText}</Loader>)
  }
  return (<Loader active inline={inline} style={style}/>)
}

export {LoadingIndicator}

export default LoadingIndicator